import React from 'react';
import { MenuContentTemplate } from '../../components';
import { AdminPortalRoutes, menus } from './adminRouter';

export const AdminPortal = ({ navigation }: any) => {
  return (
    <MenuContentTemplate navigation={navigation} menus={menus} menuTitle="Admin Menu">
      <AdminPortalRoutes />
    </MenuContentTemplate>
  );
};
